export default {
	issuer: 'token:test',
	host: 'https://test.videoland.com',
	identity_host: 'https://test-account.rtl.nl',
	v1_base: 'https://test.videoland.com/api',
	rtl_oidc_base: 'https://test-api.videoland.com/subscribe/rtl-oidc/oidc/videoland-reset-password',
	subscription_base: 'https://test-api.videoland.com/subscribe/subscription',
	newsletter_base: 'https://test-api.videoland.com/subscribe/newsletter',
	accounts_base: 'https://test-api.videoland.com/subscribe/videoland-account',
	payment_base: 'https://test-api.videoland.com/subscribe/payment',
	billing_base: 'https://test-api.videoland.com/subscribe/billing',
	statics_base: 'https://test-static.videoland.com/',
	gigya_base: 'https://cdns.gigya.com/JS/gigya.js?apiKey=',
	gigya_key: '3_sZwZsNaHv2qWmyswqgIqMymUy_4Elct1j4PQ6DIpHvJ51Zits696G3F0ee7XjkLy',
	onetrust_domain_id: 'bf9bd4ea-550d-41e9-8de4-98f08ebdbce6-test',
	api_base: 'https://test-api.videoland.com',
	bedrock: 'https://test.staging.videoland.com/',
	opentelemetry_url:
		'https://test-api.rtl.nl/monitoring/opentelemetry-collector-frontend/receivers/otlphttp/v1/traces',
};
